/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateCommentRequest,
  CreateFeedbackRequest,
  EditFeedbackRequest,
  FeedbackCommentDto,
  FeedbackTicketDto,
  ReopenFeedbackRequest,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary List
 */
export const getFeedback = (signal?: AbortSignal) => {
  return customInstance<FeedbackTicketDto[]>({
    url: `/feedback`,
    method: "GET",
    signal,
  });
};

export const getGetFeedbackInfiniteQueryKey = () => {
  return ["infinite", `/feedback`] as const;
};

export const getGetFeedbackQueryKey = () => {
  return [`/feedback`] as const;
};

export const getGetFeedbackInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedback>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getFeedback>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedbackInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedback>>> = ({
    signal,
  }) => getFeedback(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedback>>
>;
export type GetFeedbackInfiniteQueryError = void;

export function useGetFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedback>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedback>>,
          TError,
          Awaited<ReturnType<typeof getFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedback>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedback>>,
          TError,
          Awaited<ReturnType<typeof getFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedback>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedback>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List
 */

export function useGetFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedback>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedback>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeedbackInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedback>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedbackQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedback>>> = ({
    signal,
  }) => getFeedback(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedback>>
>;
export type GetFeedbackQueryError = void;

export function useGetFeedback<
  TData = Awaited<ReturnType<typeof getFeedback>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedback>>,
          TError,
          Awaited<ReturnType<typeof getFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedback<
  TData = Awaited<ReturnType<typeof getFeedback>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedback>>,
          TError,
          Awaited<ReturnType<typeof getFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedback<
  TData = Awaited<ReturnType<typeof getFeedback>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List
 */

export function useGetFeedback<
  TData = Awaited<ReturnType<typeof getFeedback>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeedbackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postFeedback = (
  createFeedbackRequest: CreateFeedbackRequest,
  signal?: AbortSignal,
) => {
  return customInstance<FeedbackTicketDto>({
    url: `/feedback`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFeedbackRequest,
    signal,
  });
};

export const getPostFeedbackMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFeedback>>,
    TError,
    { data: CreateFeedbackRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFeedback>>,
  TError,
  { data: CreateFeedbackRequest },
  TContext
> => {
  const mutationKey = ["postFeedback"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFeedback>>,
    { data: CreateFeedbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postFeedback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFeedback>>
>;
export type PostFeedbackMutationBody = CreateFeedbackRequest;
export type PostFeedbackMutationError = void;

/**
 * @summary Create
 */
export const usePostFeedback = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFeedback>>,
      TError,
      { data: CreateFeedbackRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFeedback>>,
  TError,
  { data: CreateFeedbackRequest },
  TContext
> => {
  const mutationOptions = getPostFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Download
 */
export const getFeedbackAttachmentsAttachmentId = (
  attachmentId: number,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/feedback/attachments/${attachmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetFeedbackAttachmentsAttachmentIdInfiniteQueryKey = (
  attachmentId?: number,
) => {
  return ["infinite", `/feedback/attachments/${attachmentId}`] as const;
};

export const getGetFeedbackAttachmentsAttachmentIdQueryKey = (
  attachmentId?: number,
) => {
  return [`/feedback/attachments/${attachmentId}`] as const;
};

export const getGetFeedbackAttachmentsAttachmentIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFeedbackAttachmentsAttachmentIdInfiniteQueryKey(attachmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
  > = ({ signal }) => getFeedbackAttachmentsAttachmentId(attachmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!attachmentId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackAttachmentsAttachmentIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
>;
export type GetFeedbackAttachmentsAttachmentIdInfiniteQueryError = void;

export function useGetFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download
 */

export function useGetFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetFeedbackAttachmentsAttachmentIdInfiniteQueryOptions(
      attachmentId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetFeedbackAttachmentsAttachmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFeedbackAttachmentsAttachmentIdQueryKey(attachmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
  > = ({ signal }) => getFeedbackAttachmentsAttachmentId(attachmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!attachmentId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackAttachmentsAttachmentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
>;
export type GetFeedbackAttachmentsAttachmentIdQueryError = void;

export function useGetFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download
 */

export function useGetFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeedbackAttachmentsAttachmentIdQueryOptions(
    attachmentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get
 */
export const getFeedbackId = (id: number, signal?: AbortSignal) => {
  return customInstance<FeedbackTicketDto>({
    url: `/feedback/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetFeedbackIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/feedback/${id}`] as const;
};

export const getGetFeedbackIdQueryKey = (id?: number) => {
  return [`/feedback/${id}`] as const;
};

export const getGetFeedbackIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFeedbackIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedbackId>>> = ({
    signal,
  }) => getFeedbackId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedbackId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackId>>
>;
export type GetFeedbackIdInfiniteQueryError = void;

export function useGetFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get
 */

export function useGetFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeedbackIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetFeedbackIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedbackId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedbackIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedbackId>>> = ({
    signal,
  }) => getFeedbackId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedbackId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackId>>
>;
export type GetFeedbackIdQueryError = void;

export function useGetFeedbackId<
  TData = Awaited<ReturnType<typeof getFeedbackId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedbackId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackId<
  TData = Awaited<ReturnType<typeof getFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedbackId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackId<
  TData = Awaited<ReturnType<typeof getFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedbackId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get
 */

export function useGetFeedbackId<
  TData = Awaited<ReturnType<typeof getFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeedbackId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeedbackIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Edit
 */
export const putFeedbackId = (
  id: number,
  editFeedbackRequest: EditFeedbackRequest,
) => {
  return customInstance<FeedbackTicketDto>({
    url: `/feedback/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: editFeedbackRequest,
  });
};

export const getPutFeedbackIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFeedbackId>>,
    TError,
    { id: number; data: EditFeedbackRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putFeedbackId>>,
  TError,
  { id: number; data: EditFeedbackRequest },
  TContext
> => {
  const mutationKey = ["putFeedbackId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putFeedbackId>>,
    { id: number; data: EditFeedbackRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putFeedbackId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFeedbackIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putFeedbackId>>
>;
export type PutFeedbackIdMutationBody = EditFeedbackRequest;
export type PutFeedbackIdMutationError = void;

/**
 * @summary Edit
 */
export const usePutFeedbackId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putFeedbackId>>,
      TError,
      { id: number; data: EditFeedbackRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putFeedbackId>>,
  TError,
  { id: number; data: EditFeedbackRequest },
  TContext
> => {
  const mutationOptions = getPutFeedbackIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Close
 */
export const putFeedbackIdClose = (id: number) => {
  return customInstance<FeedbackTicketDto>({
    url: `/feedback/${id}/close`,
    method: "PUT",
  });
};

export const getPutFeedbackIdCloseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFeedbackIdClose>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putFeedbackIdClose>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["putFeedbackIdClose"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putFeedbackIdClose>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return putFeedbackIdClose(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFeedbackIdCloseMutationResult = NonNullable<
  Awaited<ReturnType<typeof putFeedbackIdClose>>
>;

export type PutFeedbackIdCloseMutationError = void;

/**
 * @summary Close
 */
export const usePutFeedbackIdClose = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putFeedbackIdClose>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putFeedbackIdClose>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getPutFeedbackIdCloseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Comments
 */
export const getFeedbackIdComments = (id: number, signal?: AbortSignal) => {
  return customInstance<FeedbackCommentDto[]>({
    url: `/feedback/${id}/comments`,
    method: "GET",
    signal,
  });
};

export const getGetFeedbackIdCommentsInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/feedback/${id}/comments`] as const;
};

export const getGetFeedbackIdCommentsQueryKey = (id?: number) => {
  return [`/feedback/${id}/comments`] as const;
};

export const getGetFeedbackIdCommentsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFeedbackIdCommentsInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedbackIdComments>>
  > = ({ signal }) => getFeedbackIdComments(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getFeedbackIdComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackIdCommentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackIdComments>>
>;
export type GetFeedbackIdCommentsInfiniteQueryError = void;

export function useGetFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Comments
 */

export function useGetFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeedbackIdCommentsInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetFeedbackIdCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFeedbackIdCommentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedbackIdComments>>
  > = ({ signal }) => getFeedbackIdComments(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedbackIdComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeedbackIdCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackIdComments>>
>;
export type GetFeedbackIdCommentsQueryError = void;

export function useGetFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Comments
 */

export function useGetFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeedbackIdCommentsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add Comment
 */
export const postFeedbackIdComments = (
  id: number,
  createCommentRequest: CreateCommentRequest,
  signal?: AbortSignal,
) => {
  return customInstance<FeedbackCommentDto>({
    url: `/feedback/${id}/comments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCommentRequest,
    signal,
  });
};

export const getPostFeedbackIdCommentsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFeedbackIdComments>>,
    TError,
    { id: number; data: CreateCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFeedbackIdComments>>,
  TError,
  { id: number; data: CreateCommentRequest },
  TContext
> => {
  const mutationKey = ["postFeedbackIdComments"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFeedbackIdComments>>,
    { id: number; data: CreateCommentRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postFeedbackIdComments(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFeedbackIdCommentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFeedbackIdComments>>
>;
export type PostFeedbackIdCommentsMutationBody = CreateCommentRequest;
export type PostFeedbackIdCommentsMutationError = void;

/**
 * @summary Add Comment
 */
export const usePostFeedbackIdComments = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFeedbackIdComments>>,
      TError,
      { id: number; data: CreateCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFeedbackIdComments>>,
  TError,
  { id: number; data: CreateCommentRequest },
  TContext
> => {
  const mutationOptions = getPostFeedbackIdCommentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reopen
 */
export const putFeedbackIdReopen = (
  id: number,
  reopenFeedbackRequest: ReopenFeedbackRequest,
) => {
  return customInstance<FeedbackTicketDto>({
    url: `/feedback/${id}/reopen`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: reopenFeedbackRequest,
  });
};

export const getPutFeedbackIdReopenMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFeedbackIdReopen>>,
    TError,
    { id: number; data: ReopenFeedbackRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putFeedbackIdReopen>>,
  TError,
  { id: number; data: ReopenFeedbackRequest },
  TContext
> => {
  const mutationKey = ["putFeedbackIdReopen"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putFeedbackIdReopen>>,
    { id: number; data: ReopenFeedbackRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putFeedbackIdReopen(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFeedbackIdReopenMutationResult = NonNullable<
  Awaited<ReturnType<typeof putFeedbackIdReopen>>
>;
export type PutFeedbackIdReopenMutationBody = ReopenFeedbackRequest;
export type PutFeedbackIdReopenMutationError = void;

/**
 * @summary Reopen
 */
export const usePutFeedbackIdReopen = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putFeedbackIdReopen>>,
      TError,
      { id: number; data: ReopenFeedbackRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putFeedbackIdReopen>>,
  TError,
  { id: number; data: ReopenFeedbackRequest },
  TContext
> => {
  const mutationOptions = getPutFeedbackIdReopenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
